import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Role } from '@data/models/role.model';
import { Authorization } from '@data/models/authorization.model';
import * as _ from 'lodash';

@Component({

    selector: 'syn-acls-details-dialog',
    templateUrl: 'acls-details-dialog.component.html'
})
export class AclsDetailsDialogComponent {

    public displayedColumns = ['id', 'READ', 'EDIT', 'ADMIN'];
    public dataSource: MatTableDataSource<{ id: string; level: string }>;
    public dataCount = 0;
    public infoMessage: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { roles: Role[]; row: Authorization }
    ) {
        const globalRoles = data.roles;
        const rowRoles = data.row.roles;

        // Filter roles to display assigned ones only
        const filteredRoles = _.filter(globalRoles, role => rowRoles.includes(role.id));
        const cumulatedAcls = this.rolesToCumulatedAcls(filteredRoles);
        this.dataSource = new MatTableDataSource(cumulatedAcls);
        this.dataCount = cumulatedAcls.length;

        this.infoMessage = this.getInfoTooltip(filteredRoles);
    }

    private rolesToCumulatedAcls(roles: Role[]): Array<{ id: string; level: string }> {
        const resultMap = new Map<string, string>();
        for (const role of roles) {
            for (const acl of role.acl) {
                if (!resultMap.has(acl.entity) ||
                    resultMap.get(acl.entity) === 'READ' && acl.level === 'EDIT' ||
                    acl.level === 'ADMIN') {
                    resultMap.set(acl.entity, acl.level);
                }
            }
        }
        return Array.from(resultMap).map(entry => {
            return { id: entry[0], level: entry[1] };
        });
    }

    private getInfoTooltip(roles: Role[]): string {
        return roles
            .filter((role) => role.description)
            .map((role) => role.description)
            .join('\n');
    }

}
